/**
 * VHF — Filtro Vertical Horizontal.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLOutros.cs, classe
 * FML.VHF). Painel próprio, 1 linha:
 *
 *   VHF = (HHV(C,N) − LLV(C,N)) / SUM(|C − REF(C,1)|, N)
 *
 * Mede o nível de atividade da tendência (Adam White): valores altos indicam
 * mercado em tendência; baixos, mercado lateral. Paridade provada em
 * __tests__/vhf.silverlight.test.js.
 */
import { hhv, llv, sub, abs, ref, sum, div } from "./silverlightDsl";
import { VHF as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );

    const range = sub(hhv(close, period), llv(close, period));
    const movement = sum(abs(sub(close, ref(close, 1))), period);
    const vhf = div(range, movement);

    return vhf.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    // SUM(f,N) emite a partir de i>N e f já perde a barra 0 pelo REF — o
    // warm-up observado no engine é N+2.
    return Math.max(0, period + 2);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
